import { createSelector } from 'reselect';
import { ALERT_RULES_REDUCER_KEY } from './reducer';

export const getAlertRulesStore = (state) => state[ALERT_RULES_REDUCER_KEY];

export const getLastSyncDate = (state: any) => getAlertRulesStore(state).lastSyncDate;

export const getAllAlertRules = (state) => getAlertRulesStore(state).resourcesById;

// get alert by name
export const getAlertRuleFromStore = createSelector(
  (state) => getAllAlertRules(state),
  (state, type) => type,
  (alertsStore, type) => alertsStore && alertsStore.find((a) => a.type === type)
);

